import { loginByPassword, loginByCode, register, logout } from '../../api/login'
import { setToken, removeToken } from '../../utils/auth'

const state = {
  userId: '',
  user: ''
}

const getters = {
  getUserId (state) {
    return state.userId
  },
  getUser (state) {
    return state.user
  }
}

// 同步调用
const mutations = {
  SET_USERID: (state, userId) => {
    state.userId = userId
  },
  SET_USER: (state, user) => {
    state.user = user
  }
}

const actions = {
  // 账号密码登录
  LoginByPassword ({ commit }, userInfo) {
    let loginData = {}
    loginData.username = userInfo.username.trim()
    loginData.password = userInfo.password
    removeToken('userId')
    removeToken('username')
    return new Promise((resolve, reject) => {
      loginByPassword(loginData).then(response => {
        const data = response
        if (data.code === '1') {
          commit('SET_USERID', data.userinfo.user_id)
          commit('SET_USER', data.userinfo.username)
          setToken('userId', data.userinfo.user_id)
          setToken('username', data.userinfo.username)
          resolve('success')
        } else {
          resolve('fail')
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 验证码登录
  LoginByCode ({ commit }, userInfo) {
    let loginData = {}
    loginData.mobile = userInfo.mobile.trim()
    loginData.vercode = userInfo.vercode
    removeToken('userId')
    removeToken('username')
    return new Promise((resolve, reject) => {
      loginByCode(loginData).then(response => {
        const data = response
        if (data.code === '1') {
          commit('SET_USERID', data.userinfo.user_id)
          commit('SET_USER', data.userinfo.username)
          setToken('userId', data.userinfo.user_id)
          setToken('username', data.userinfo.username)
          resolve('success')
        } else {
          resolve(data.msg)
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 注册
  Register ({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      userInfo.username = userInfo.username.trim()
      register(userInfo).then(response => {
        const data = response
        if (data.code === '1') {
          commit('SET_USERID', data.userinfo.user_id)
          commit('SET_USER', data.userinfo.username)
          setToken('userId', data.userinfo.user_id)
          setToken('username', data.userinfo.username)
          resolve('success')
        } else {
          resolve(data.msg)
        }
      }).catch(error => {
        resolve(error)
      })
    })
  },

  // 登出
  LogOut ({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        commit('SET_USERID', '')
        commit('SET_USER', '')
        removeToken('userId')
        removeToken('username')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
